// src/store/modules/favorites.ts
import { Module } from 'vuex';
import { RootState } from '@/store/index';

type FavoritesState = {
  orderId: string;
  isLike: boolean;
};

const favoritesModule: Module<FavoritesState, RootState> = {
  namespaced: true,

  state: {
    orderId: '',
    isLike: false,
  },

  getters: {
    favorites(state) {
      return state;
    },
  },

  mutations: {
    set(state, value: Partial<FavoritesState>) {
      Object.assign(state, value);
    },
    clear(state) {
      state.orderId = '';
      state.isLike = false;
    },
  },

  actions: {
    setFavorite({ commit }, payload: FavoritesState) {
      commit('set', payload);
    },
    clearFavorite({ commit }) {
      commit('clear');
    },
  },
};

export default favoritesModule;